import { render } from "./DjiOutBoundOrderShip.vue?vue&type=template&id=478b102a&scoped=true"
import script from "./DjiOutBoundOrderShip.vue?vue&type=script&lang=js"
export * from "./DjiOutBoundOrderShip.vue?vue&type=script&lang=js"

import "./DjiOutBoundOrderShip.vue?vue&type=style&index=0&id=478b102a&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478b102a"]])

export default __exports__